import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.string.link";
import React from "react";
import DragRail from "web/react/components/drag-rail/drag-rail";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import styles from "./homepage-breakout-brands.css";
export function TitleItem(_ref) {
  var title = _ref.title;
  return React.createElement("div", {
    className: styles.titleItem
  }, React.createElement("p", {
    className: styles.title
  }, title));
}
export function LinkItem(_ref2) {
  var link = _ref2.link;
  return React.createElement("a", {
    className: styles.link,
    href: link.url
  }, React.createElement("h4", {
    className: styles.linkTitle
  }, " ", link.title, " "), React.createElement(LazyLoadImage, {
    className: styles.linkImage,
    src: link.image_url,
    alt: link.image_alt
  }));
}

function HomepageBreakoutBrands(_ref3) {
  var designerTitle = _ref3.designer_title,
      designerLinks = _ref3.designer_links,
      topDesignerCategoryTitle = _ref3.top_dc_title,
      topDesignerCategoryLinks = _ref3.top_dc_links,
      bottomDesignerCategoryTitle = _ref3.bottom_dc_title,
      bottomDesignerCategoryLinks = _ref3.bottom_dc_links;
  return React.createElement("div", {
    className: styles.homepageBreakoutBrandsWrapper
  }, React.createElement(DragRail, {
    id: "homepage-designer-rail",
    className: styles.dragRail
  }, React.createElement("div", {
    className: styles.itemsContainer
  }, React.createElement(TitleItem, {
    title: designerTitle
  }), designerLinks.map(function (designerLink) {
    return React.createElement(LinkItem, {
      key: designerLink.title,
      link: designerLink
    });
  }))), React.createElement(DragRail, {
    id: "homepage-top-dc-rail",
    className: styles.dragRail
  }, React.createElement("div", {
    className: styles.itemsContainer
  }, topDesignerCategoryLinks.slice(0, 2).map(function (topDesignerCategoryLink) {
    return React.createElement(LinkItem, {
      key: topDesignerCategoryLink.title,
      link: topDesignerCategoryLink
    });
  }), React.createElement(TitleItem, {
    title: topDesignerCategoryTitle
  }), topDesignerCategoryLinks.slice(2).map(function (topDesignerCategoryLink) {
    return React.createElement(LinkItem, {
      key: topDesignerCategoryLink.title,
      link: topDesignerCategoryLink
    });
  }))), React.createElement(DragRail, {
    id: "homepage-bottom-dc-rail",
    className: styles.dragRail
  }, React.createElement("div", {
    className: styles.itemsContainer
  }, bottomDesignerCategoryLinks.slice(0, 1).map(function (bottomDesignerCategoryLink) {
    return React.createElement(LinkItem, {
      key: bottomDesignerCategoryLink.title,
      link: bottomDesignerCategoryLink
    });
  }), React.createElement(TitleItem, {
    title: bottomDesignerCategoryTitle
  }), bottomDesignerCategoryLinks.slice(1).map(function (bottomDesignerCategoryLink) {
    return React.createElement(LinkItem, {
      key: bottomDesignerCategoryLink.title,
      link: bottomDesignerCategoryLink
    });
  }))));
}

export default HomepageBreakoutBrands;